var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgStore = function SvgStore(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 23,
    height: 22,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "#303030",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: "M14.25 19.25V14.3c0-.513 0-.77-.1-.966a.9.9 0 0 0-.4-.4c-.197-.1-.453-.1-.967-.1h-2.566c-.514 0-.77 0-.966.1a.9.9 0 0 0-.401.4c-.1.196-.1.453-.1.966v4.95M3.25 6.417a2.75 2.75 0 0 0 5.5 0 2.75 2.75 0 0 0 5.5 0 2.75 2.75 0 1 0 5.5 0M6.183 19.25h10.634c1.026 0 1.54 0 1.932-.2.345-.176.625-.456.801-.801.2-.392.2-.906.2-1.932V5.683c0-1.026 0-1.54-.2-1.932a1.83 1.83 0 0 0-.801-.801c-.392-.2-.906-.2-1.932-.2H6.183c-1.026 0-1.54 0-1.932.2a1.83 1.83 0 0 0-.801.801c-.2.392-.2.906-.2 1.932v10.634c0 1.026 0 1.54.2 1.932.176.345.456.625.801.801.392.2.906.2 1.932.2"
  })));
};
export default SvgStore;